export const HELPDESK_SURVEY_ID = process.env.HELPDESK_SURVEY_ID
